import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import hyAmLocale from 'dayjs/locale/hy-am';
import 'dayjs/locale/ru';
import 'dayjs/locale/tr';
import 'dayjs/locale/hi';
import i18n from 'i18next';

dayjs.extend(utc);

const hyLocale = (hyAmLocale as any)?.default || hyAmLocale;
dayjs.locale('hy-am', hyLocale);
dayjs.locale('hy', hyLocale);

export interface FormatDateOptions {
  includeTime?: boolean;
  includeYear?: boolean;
  fallback?: string;
  locale?: string;
}

const resolveLocale = (localeOverride?: string): string => {
  const lang =
    localeOverride ||
    i18n.language ||
    (typeof window !== 'undefined' ? localStorage.getItem('language') : null) ||
    dayjs.locale() ||
    'en';
  const base = lang.toLowerCase().split('-')[0];
  if (base === 'hy') return 'hy-am';
  return base;
};

export function formatLocalTime(
  dateStr?: dayjs.ConfigType,
  optionsOrIncludeTime: boolean | FormatDateOptions = true,
  fallbackStr = '',
): string {
  const options: FormatDateOptions =
    typeof optionsOrIncludeTime === 'boolean'
      ? { includeTime: optionsOrIncludeTime, fallback: fallbackStr }
      : optionsOrIncludeTime || {};

  const { includeTime = true, includeYear = true, fallback = fallbackStr, locale } = options;

  if (dateStr === null || dateStr === undefined || dateStr === '') return fallback;

  const parsed = dayjs.utc(dateStr).local();
  if (!parsed.isValid()) return fallback || String(dateStr);

  let pattern = 'D MMM';
  if (includeYear) pattern += ', YYYY';
  if (includeTime) pattern += ', HH:mm';

  const resolvedLocale = resolveLocale(locale);
  return parsed.locale(resolvedLocale).format(pattern);
}
